import { PenLine } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const esignNav: NavEntry = {
  label: 'E-signatures',
  icon: PenLine,
  path: '/quality/esign',
  permission: 'esign:read',
  order: 23,
}
